<script>
export default {
  name: 'IconLinkedin',
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#0E76A8"
      fill-rule="evenodd"
      d="M21.3333333,19.6666667 L17.2814166,19.6666667 L17.2814166,13.8076669 C17.2814166,12.2740817 16.6475972,11.2271456 15.2538413,11.2271456 C14.1877744,11.2271456 13.5949161,11.9336407 13.3189675,12.6145226 C13.2154868,12.8589144 13.2316557,13.1993554 13.2316557,13.5397964 L13.2316557,19.6666667 L9.21746629,19.6666667 C9.21746629,19.6666667 9.26920665,9.28801947 9.21746629,8.3446031 L13.2316557,8.3446031 L13.2316557,10.1215129 C13.468799,9.34458176 14.7515287,8.23574737 16.7985066,8.23574737 C19.3380958,8.23574737 21.3333333,9.86431453 21.3333333,13.3711767 L21.3333333,19.6666667 L21.3333333,19.6666667 Z M5.15800408,6.92841135 L5.1321339,6.92841135 C3.83862496,6.92841135 3,6.06290154 3,4.96580649 C3,3.84736719 3.86341722,3 5.18279633,3 C6.50109752,3 7.31169646,3.84523276 7.33756664,4.96260485 C7.33756664,6.0596999 6.50109752,6.92841135 5.15800408,6.92841135 L5.15800408,6.92841135 L5.15800408,6.92841135 Z M3.46242944,8.3446031 L7.03574788,8.3446031 L7.03574788,19.6666667 L3.46242944,19.6666667 L3.46242944,8.3446031 L3.46242944,8.3446031 Z"
    />
  </svg>
</template>
